const DAY = 86_400_000;
/** Between stretches the plan picks up from where the last one ended. */
export const planFrom = (plan) => (plan.ended && plan.to !== null ? plan.to : plan.from);
/** When the stretch began: the last meeting that closed one, else the book's start, else now. */
export function planStartAt(plan, startedAt, now = new Date()) {
    const met = plan.boundaries.at(-1)?.metAt;
    return met ? new Date(met) : startedAt ? new Date(startedAt) : now;
}
/** The meeting the stretch is heading for, only while it's ahead. */
export const planDeadline = (meetingAt, now = new Date()) => meetingAt && new Date(meetingAt) > now ? new Date(meetingAt) : null;
/** `total` is the book's pages, `end` the page the meeting covers up to (the total for the whole book). */
export function planNumbers(o) {
    const days = o.deadline ? Math.max(1, (o.deadline.getTime() - o.startAt.getTime()) / DAY) : null;
    return {
        pace: o.total && o.end && days ? Math.ceil((o.end - o.from) / days) : null,
        paceToday: o.total && days ? Math.ceil((o.total - o.from) / days) : null,
        reachAtUsual: o.usualPace && days ? Math.round(o.from + o.usualPace * days) : null,
    };
}
/** The date a page falls on when the stretch is read evenly from its start to the meeting. */
export function derivedLandmarkDate(page, o) {
    if (!o.deadline || !o.end || o.end <= o.from)
        return null;
    const frac = Math.max(0, Math.min(1, (page - o.from) / (o.end - o.from)));
    return new Date(o.startAt.getTime() + frac * (o.deadline.getTime() - o.startAt.getTime()));
}
/** The next landmark to suggest: halfway across the widest gap between the start, the landmarks and the end. */
export function suggestLandmark(from, total, pages) {
    if (!total)
        return null;
    const pts = [from, ...pages, total].sort((a, b) => a - b);
    let best = { lo: from, hi: total, gap: -1 };
    for (let i = 1; i < pts.length; i++) {
        const gap = pts[i] - pts[i - 1];
        if (gap > best.gap)
            best = { lo: pts[i - 1], hi: pts[i], gap };
    }
    if (best.gap < 2)
        return null;
    return { page: Math.round((best.lo + best.hi) / 2), lo: best.lo, hi: best.hi };
}
//# sourceMappingURL=plan.js.map